"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.courtroomControlsContract = exports.TriggerHearingSectionRequest = void 0;
const tslib_1 = require("tslib");
const core_1 = require("@ts-rest/core");
const zod_1 = tslib_1.__importDefault(require("zod"));
const resources_1 = require("./resources");
const case_schemas_1 = require("./resources/case.schemas");
const refine_1 = require("./util/refine");
const TriggerHearingSectionRequestSchema = zod_1.default.object({
    locationId: zod_1.default.string().uuid(),
    courtSystemId: zod_1.default.string().uuid(),
    title: case_schemas_1.CaseTitleSchema.nullable(),
    caseReference: case_schemas_1.CaseReferenceSchema.nullable(),
    startDateTime: resources_1.LocalDateTimeNoNanosSchema.nullable().describe('The start time of the hearing section, or now if unspecified'),
});
exports.TriggerHearingSectionRequest = TriggerHearingSectionRequestSchema.refine((refine_1.is));
const c = (0, core_1.initContract)();
const path = '/courtroom-controls';
exports.courtroomControlsContract = c.router({
    triggerHearingSection: {
        method: 'POST',
        path: `${path}/trigger-hearing-section`,
        headers: resources_1.UserOrApiAuthHeadersSchema,
        responses: {
            [201]: case_schemas_1.HearingSection,
            [409]: case_schemas_1.NoRecordingAtTimeError.or(case_schemas_1.OutOfSessionError).or(case_schemas_1.CrossesSessionBoundaryError),
        },
        body: exports.TriggerHearingSectionRequest,
        summary: 'Creates a hearing section at a current time (or now if unspecified). The endTime is inferred to be either the end of the enclosing session, or the start of the next hearing section. All hearing section conflicts are automatically resolved.',
    },
}, {
    strictStatusCodes: true,
    commonResponses: (0, resources_1.errorResponses)(),
    validateResponseOnClient: true,
});
